import React from 'react';
import { Instagram, Twitter, Mail } from 'lucide-react';
import { socialLinks, companyInfo } from '../data/mock';

const Footer = () => {
  const getIcon = (name) => {
    switch (name) {
      case 'Instagram':
        return <Instagram className="social-icon" />;
      case 'Twitter/X':
        return <Twitter className="social-icon" />;
      case 'Substack':
        return <Mail className="social-icon" />;
      default:
        return null;
    }
  };

  return (
    <footer className="site-footer">
      <div className="footer-noise" />
      <div className="footer-border-top" />
      
      <div className="footer-content">
        <div className="footer-brand">
          <span className="footer-logo">{companyInfo.name}</span>
        </div>
        
        <div className="footer-social">
          {socialLinks.map((link) => (
            <a
              key={link.name}
              href={link.url}
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.name}
            >
              {getIcon(link.name)}
              <span className="social-handle">{link.handle}</span>
            </a>
          ))}
        </div>
        
        <div className="footer-bottom">
          <p className="copyright">© 2025 {companyInfo.name}. NO RIGHTS RESERVED.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
